

var init = false;
var swiper, elSwiper;
function swiperCard() {
  if (window.innerWidth <= 999) {
    const elementWithSwiper = document.querySelector('.template-page-landing-page-v1 .icon-columns-wrapper.swiper');
      elSwiper = new Swiper(elementWithSwiper, {
      spaceBetween: 20,
      pagination: {
        el: ".swiper-pagination",
        clickable: true
      },
      on: {
        activeIndexChange: () => {
          if (!elSwiper.firstMove) {
            elSwiper.firstMove = true;
            const slides = elSwiper.slides;
            slides.forEach((slide) => {
              slide.style.transition = "width 0.4s ease-in-out";
            });
          }
        },
        click: (instance, event) => {
          instance.slideTo(instance.clickedIndex);
        }
      },
      observer: true,
      observeParents: true,
    });
  } else {
    const elementWithSwiper = document.querySelector('.template-page-landing-page-v1 .icon-columns-wrapper.swiper');
    elementWithSwiper.swiper.destroy();
  }
  if (window.innerWidth <= 500) {
    if (!init) {
      init = true;
      const multiColumnLandingPageWrapper = document.querySelector('.template-page-landing-page-v1 .multi-column-wrapper');
      multiColumnLandingPageWrapper?.classList?.add('swiper');
      const multiColumnLandingPage = document.querySelector('.template-page-landing-page-v1 .multi-column');
      multiColumnLandingPage?.classList?.add('swiper-wrapper')
      const multiColumnItems = multiColumnLandingPage?.querySelectorAll('.multi-column__item');
      multiColumnItems?.forEach((column) => column.classList?.add('swiper-slide'));
      swiper = new Swiper(".multi-column-wrapper.swiper", {
        spaceBetween: 20,
        pagination: {
          el: ".swiper-pagination",
          clickable: true
        },
        on: {
          activeIndexChange: () => {
            if (!swiper.firstMove) {
              swiper.firstMove = true;
              const slides = swiper.slides;
              slides.forEach((slide) => {
                slide.style.transition = "width 0.4s ease-in-out";
              });
            }
          },
          click: (instance, event) => {
            instance.slideTo(instance.clickedIndex);
          }
        }
      });
    }
  } else if (init) {
    const multiColumnLandingPageWrapper = document.querySelector('.template-page-landing-page-v1 .multi-column-wrapper');
    multiColumnLandingPageWrapper?.classList?.remove('swiper');
    const multiColumnLandingPage = document.querySelector('.template-page-landing-page-v1 .multi-column');
    multiColumnLandingPage?.classList?.remove('swiper-wrapper')
    const multiColumnItems = multiColumnLandingPage?.querySelectorAll('.multi-column__item');
    multiColumnItems?.forEach((column) => column.classList?.remove('swiper-slide'));
    swiper.destroy();
    init = false;
  }
  const swipersAll = document.querySelectorAll('.template-page-landing-page-v1 .swiper');
  swipersAll?.forEach(swiper => {
    swiper?.on('slideChange', function() {
        swiper.pagination.render();
	swiper.pagination.update();
    });
});
}
swiperCard();
window.addEventListener("resize", swiperCard);
window.addEventListener("load", function(){
  swiperCard();
});